/* Cosmo blog post template behavior. Shared by the local preview and the Shopify section.
   1. tidy the post's pasted-in HTML  2. table of contents + scrollspy
   3. place the product card  4. share buttons  5. reading progress */
(function () {
  var root = document.querySelector('.cb');
  if (!root) return;
  var prose = root.querySelector('.cb-prose');
  if (!prose) return;

  // ---- 1. tidy ------------------------------------------------------------
  prose.querySelectorAll('meta, style, script, font:empty').forEach(function (n) { n.remove(); });
  prose.querySelectorAll('p').forEach(function (p) {
    var media = p.querySelector('img, iframe, video, picture');
    if (!media && !p.textContent.replace(/\u00a0/g, ' ').trim()) { p.remove(); return; }
    // a paragraph that only holds an image becomes a figure block
    if (media && media.tagName === 'IMG' && !p.textContent.replace(/\u00a0/g, ' ').trim()) p.classList.add('cb-fig');
  });
  prose.querySelectorAll('img').forEach(function (img) {
    img.removeAttribute('style');
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.loading = 'lazy';
    img.decoding = 'async';
  });
  prose.querySelectorAll('table').forEach(function (t) {
    if (t.parentElement.classList.contains('cb-table')) return;
    var w = document.createElement('div'); w.className = 'cb-table';
    t.parentNode.insertBefore(w, t); w.appendChild(t);
  });
  prose.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"], iframe[src*="wistia"]').forEach(function (f) {
    var host = f.closest('p') || f;
    var w = document.createElement('div'); w.className = 'cb-embed';
    host.parentNode.insertBefore(w, host); w.appendChild(f);
    if (host !== f && !host.textContent.trim()) host.remove();
  });
  // ---- 2. table of contents ----------------------------------------------
  var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
  var label = function (h) { return h.textContent.replace(/\s+/g, ' ').trim(); };
  var toc = root.querySelector('.cb-toc');
  var used = {};
  heads.forEach(function (h) {
    var base = h.id || label(h).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    var id = base, n = 2;
    while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id = base + '-' + n++;
    used[id] = 1; h.id = id;
  });
  if (toc && heads.length >= 2) {
    var ol = toc.querySelector('ol');
    heads.forEach(function (h) {
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = label(h);
      li.appendChild(a); ol.appendChild(li);
    });
    var links = ol.querySelectorAll('a');
    var mq = window.matchMedia('(min-width: 1024px)');
    var syncOpen = function () { toc.open = mq.matches; };
    syncOpen(); (mq.addEventListener ? mq.addEventListener('change', syncOpen) : mq.addListener(syncOpen));
    toc.querySelector('summary').addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    ol.addEventListener('click', function (e) { if (e.target.tagName === 'A' && !mq.matches) toc.open = false; });
    var spy = function () {
      var y = window.scrollY + 140, on = -1;
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top + window.scrollY <= y) on = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === on); });
    };
    window.addEventListener('scroll', spy, { passive: true }); spy();
  } else if (toc) {
    toc.closest('.cb-rail').classList.add('cb-rail--empty');
    toc.remove();
  }

  // ---- 3. product card: move it in front of heading N+1 ------------------
  var cta = root.querySelector('.cb-cta[data-after]');
  if (cta) {
    var after = parseInt(cta.getAttribute('data-after'), 10) || 0;
    var target = heads[after];          // after section 2 = in front of the 3rd heading
    if (after > 0 && target) prose.insertBefore(cta, target);
    else if (after > 0) prose.appendChild(cta);
  }

  // ---- 4. share -----------------------------------------------------------
  root.querySelectorAll('[data-share="copy"]').forEach(function (b) {
    b.addEventListener('click', function () {
      var url = b.getAttribute('data-url') || location.href;
      var done = function () { b.classList.add('is-copied'); setTimeout(function () { b.classList.remove('is-copied'); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    });
  });

  // ---- 5. reading progress ------------------------------------------------
  var bar = root.querySelector('.cb-progress');
  if (bar) {
    var tick = function () {
      var r = prose.getBoundingClientRect(), total = r.height - window.innerHeight * 0.6;
      var p = Math.min(1, Math.max(0, -r.top / (total > 0 ? total : 1)));
      bar.style.transform = 'scaleX(' + p + ')';
    };
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick();
  }
})();
